/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Detail_Overage_AllowedInputs */



/**
* | output |
* | --- |
* | "Overage allowed" |
*
* @param {Partner_Dashboard_Detail_Overage_AllowedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_detail_overage_allowed = /** @type {((inputs?: Partner_Dashboard_Detail_Overage_AllowedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Detail_Overage_AllowedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mehrverbrauch erlaubt")
	return /** @type {LocalizedString} */ ("Overage allowed")
});